export default __webpack_public_path__ + "static/media/logo-trace.0aafe551.png";